// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2sIEk","colMin":"styles_colMin__2pNs_"};